import { smallScreenSize } from '@/styles';
import { useWindowSize } from './windowSize';

export const useSmallScreen = () => {
  return useWindowSize().width < smallScreenSize;
};
